import Verification from "./Verification";

const MFOrderClientSide = () => {
  return <Verification />;
};

export default MFOrderClientSide;
